import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import { formatLimitString, loadingPrincipal } from '../../functions';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

export default class NuevasOportunidades extends Component {
  constructor(props){
    super(props);
    this.state = {
      resource: [],
      response: [],
      error: [],
      key: 0,
      clave: this.props.clave,
      title: this.props.titulo,
      security: JSON.parse(localStorage.getItem('userBulletin'))
    }
  }

  componentDidMount(){
    var code = 'NOTI';
    var key = this.props.clave;
    var url = `${API_URL}BulletinResourceUX/${key}/${code}`;
    axios.get(url).then(response => response.data)
    .then((data) => {
      var arr =data.result.filter(item => item.cRec_Id===6);
      this.setState({ resource: arr });

      // Hide loader
      document.querySelector('.loader').classList.add('loader--hide');
      document.getElementById('content').removeAttribute("hidden");
    }).catch(error => {
    });
  }

  render(){
    
    return (
      this.state.resource.length > 0
      ? (
        <div className="new-opportunities gray-bg-semi-dark">
          <div className="boletin__section">
            <div className="row boletin__title-row">
              <div className="col-sm-12  boletin__title-name-section">
                <span className={" boletin__title-name boletin__title-name--" + this.props.clase}>{this.state.title}</span>
              </div>
            </div>
            <div className="loader"></div>
            <div className="row new-opportunity__row" hidden={true} id="content">
              {this.state.resource.map((resource, index) => (
                <div className="col-sm-4" key={resource.nRecursoCodigo}>
                  <Link to={`/${this.props.clave}/${resource.nRecursoCodigo}`} className="new-opportunity__more-info-link">
                  <div className={"new-opportunity__item new-opportunity__item--" + this.props.clase}>
                    <p className="new-opportunity__item-title"> {formatLimitString(resource.sTituloRecurso,50)} </p>
                    <p className="new-opportunity__item-extract"> {resource.sResumenRecurso} </p>
                    <div className="new-opportunity__more-info">
                      
                        <span className="new-opportunity__more-info-text">Más info</span>
                        &nbsp;&nbsp;
                        <span className="new-opportunity__more-info-arrow">
                          <i className="fas fa-chevron-right"></i>
                        </span>
                    </div>
                  </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      )
      : ""
    );
  }
}
